module.exports = __webpack_public_path__ + "img/index_tip_click_mobile.7e41811c.png";